import { Volume2, VolumeX } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { playClick, setClickSoundEnabled, useClickSoundEnabled } from '@/lib/clickSound';

/**
 * The speaker in the top bar: click sounds on or off for THIS PC.
 *
 * Per terminal rather than per venue, like the assist mute: the owner wants
 * the till to click, and a phone used on the floor to stay quiet, and those
 * are different machines. Turning it on plays one click straight away, so
 * the press that enabled it is the first thing heard.
 */
export function ClickSoundToggle() {
  const { t } = useTranslation();
  const enabled = useClickSoundEnabled();
  const label = enabled ? t('topbar.clickSoundOn') : t('topbar.clickSoundOff');

  return (
    <button
      type="button"
      data-click-sound-toggle
      aria-pressed={enabled}
      title={label}
      aria-label={label}
      onClick={() => {
        const next = !enabled;
        setClickSoundEnabled(next);
        if (next) playClick();
      }}
      className="rounded-control p-2 text-content-secondary hover:bg-hover hover:text-content"
    >
      {enabled ? (
        <Volume2 className="h-4 w-4" aria-hidden />
      ) : (
        <VolumeX className="h-4 w-4" aria-hidden />
      )}
    </button>
  );
}
